export default "__VITE_ASSET__9d$I4VUr__"